import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/out_25.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image120.webp';
import slideImg2 from '../images/image36.webp';
import slideImg3 from '../images/image97_.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const theMeadowsConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'The Meadows Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in The Meadows, FL. Sam\'s Tree Service handles hazardous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_the_meadows',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving The Meadows',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in The Meadows Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we understand what it takes to maintain the 
     lush, well established landscapes that define <strong>The Meadows</strong>. Mature trees 
     are a defining feature of this community but they also require expert care to stay 
     safe. Overgrown canopies, aging limbs over golf course homes, and storm weakened 
     trunks all demand a professional touch, and that's exactly what our team delivers.`,

    `We specialize in <strong>dangerous and overgrown tree situations</strong> large limbs 
     threatening rooftops and lanais, trees with structural damage from wind or disease, and 
     dense canopies that increase storm risk. We work carefully to preserve your landscape's 
     beauty while eliminating the hazards.`,

    `<strong>Sam's Tree Service</strong> brings reliable, affordable, and expert tree care 
     to <strong>The Meadows</strong> and surrounding <strong>North Sarasota</strong> 
     communities keeping your property safe, beautiful, and storm ready year round.`,
  ],

  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'The Meadows, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_TheMeadows = () => <LocationPage config={theMeadowsConfig} />;
export default Services_TheMeadows;
